export namespace LanguageStateActions {
    export class SetLanguage {
        public static readonly type = "[Language] SetLanguage";
        constructor(public language: string) {}
    }
}
